import { UseAuthResultV2 } from "core/auth/model";
import { getClientDetails, getFlutterUser, getRefreshedUser, onLogout } from "core/javascriptChannels";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { useEffect, useState } from "react";
import { hasAuthParams, useAuth as oidcAuthContext } from "react-oidc-context";
import { UserAuthState } from "shared/core/state/userAuthState";
import { isExpiring } from "core/helpers/dates";
import { appInsightsLogger } from "core/monitoring/AppInsights";

export const useAuth = (): UseAuthResultV2 => {
  //handle use Auth data for flutter
  const isMobile = !!window.flutter_inappwebview;
  const [mobileUserAuth, setMobileUserAuth] = useState<UseAuthResultV2>({
    shouldAuthenticate: false,
    isAuthenticated: false,
    isLoading: true,
    signinRedirect: onLogout,
    signoutRedirect: onLogout,
  });

  useEffect(() => {
    const fetchMobileUser = async () => {
      try {
        const clientDetails = await getClientDetails();
        const authUserResponse = await getFlutterUser();
        let userResponse = authUserResponse;

        if (isExpiring(JSON.parse(authUserResponse).expires_at)) {
          const refreshedUser = await getRefreshedUser();
          userResponse = refreshedUser;
        }

        ClientInfoState.set(JSON.parse(clientDetails));
        UserAuthState.set(JSON.parse(userResponse));
        setMobileUserAuth((prevUser) => ({ ...prevUser, shouldAuthenticate: false, isAuthenticated: true }));
      } catch (err) {
        appInsightsLogger.error("useAuthError", err);
        setMobileUserAuth((prevUser) => ({ ...prevUser, shouldAuthenticate: true, isAuthenticated: false }));
      } finally {
        setMobileUserAuth((prevUser) => ({ ...prevUser, isLoading: false }));
      }
    };

    isMobile && fetchMobileUser();
  }, [isMobile]);

  if (isMobile) {
    return mobileUserAuth;
  }

  const { signinRedirect, signoutRedirect, isAuthenticated, isLoading } = oidcAuthContext();
  const shouldAuthenticate = !hasAuthParams() && !isAuthenticated && !isLoading;

  return {
    isAuthenticated,
    isLoading,
    signinRedirect,
    signoutRedirect,
    shouldAuthenticate,
  };
};
